import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_SIGN_CONFIRM_USE_MONORAIL_SOA_ENDPOINT = createFcmDetails(
	'sign_confirm_use_monorail_soa_endpoint',
	{
		owner: 'Site Platform',
		context: 'Signature Confirm API call from corgi to monorail',
		import: false,
		description: `
		Toggles monorail signature confirm API calls to use the new /soa endpoint.

		Related to https://change.atlassian.net/browse/CHANGE-78159
	`,
	},
);
